export default "__VITE_ASSET__BnYWAQwW__"